import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify'; // Import toast from react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import toast CSS
import Logo from "../../../assets/logo.jpg";
const apiBase = process.env.REACT_APP_API;

const Login = () => {
  const [formData, setFormData] = useState({
    phone_number: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const { phone_number, password } = formData;
    const sanitizedPhoneNumber = phone_number.replace(/\s+/g, "");
    
    try {
      const response = await axios.post(`${apiBase}/auth/login`, {
        phone_number : sanitizedPhoneNumber,
        password,
      });
      localStorage.setItem("token", response.data.token); // Save token to local storage

      // Show success toast
      toast.success("User login successful!");

      if(response.data.type === "admin"){
        navigate("/admin");
      }else{
        navigate("/profile"); 
      }
    } catch (err) {
      const error_message = err.response?.data?.error?.message || "Login failed!";
      console.error(error_message);

      // Show error toast
      toast.error(error_message);
    }finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="bg-white flex flex-col items-center justify-center m-8 mt-24 sm:mt-36">
      <div className="flex flex-col justify-center items-center">
        <img src={Logo} alt="logo" className="size-28 rounded-full" />
        <h1 className="text-center text-myBlue font-semibold text-4xl mt-4 mb-1">
          Welcome to A/L Guidance
        </h1>
        <p className="text-center w-5/6 font-light mb-4">
          Start your journey with our expert tutors and advanced learning resources. Let’s make bio learning both effective and enjoyable!
        </p>
      </div>
      <div className="flex flex-col justify-center items-center w-full max-w-md bg-white rounded-2xl shadow-lg p-6 space-y-4 md:space-y-6 border">
        <h2 className="text-xl font-bold leading-tight text-myBlue">Log In</h2>
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6 w-full">
          <div>
            <label
              htmlFor="phone_number"
              className="block mb-2 text-sm font-medium text-myBlack"
            >
              Phone Number:
            </label>
            <input
              type="text"
              id="phone_number"
              name="phone_number"
              placeholder="Enter your phone number"
              value={formData.phone_number}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div>
            <label
              htmlFor="password"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Password:
            </label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
            <Link
              to="/forget"
              className="text-myBlue flex justify-end mt-4 hover:underline text-sm font-medium text-gray-500"
            >
              Forgot password?
            </Link>
          </div>
          <div className="flex flex-col items-center space-y-5">
          {
              !isLoading ? (
                <button
                type="submit"
                className="signupButton mt-4 text-white bg-myBlue hover:bg-myPurple focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-16 py-2.5 text-center flex justify-center items-center"
              >
                Log In
              </button>
              ) :
              (
                <button 
                className="signupButton flex items-center justify-center mt-4 text-white bg-myBlue hover:bg-myPurple focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-16 py-2.5 text-center flex justify-center items-center"

>
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
                
              </button>
              )
            }
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-gray-500">
                Don't have an account?{" "}
                <Link to="/register" className="text-myBlue hover:underline">
                  Register
                </Link>
              </p>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Login;
